import { adminApi } from '~/api'
import { useMutation } from '@tanstack/react-query'

export const useCreateCourseMutation = () => {
  return useMutation((values) => {
    return adminApi.createCourse({
      ...values,
      start_at: values.datetime[0].format('YYYY-MM-DD HH:mm:ss'),
      end_at: values.datetime[1].format('YYYY-MM-DD HH:mm:ss')
    })
  })
}

export const useUpdateCourseMutation = (id) => {
  return useMutation((values) => {
    return adminApi.editCourse(id, {
      ...values,
      start_at: values.datetime[0].format('YYYY-MM-DD HH:mm:ss'),
      end_at: values.datetime[1].format('YYYY-MM-DD HH:mm:ss')
    })
  })
}
